import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_helper } from "../src/dbh_helper";
import { dbh_suchergebnis } from "./dbh_suchergebnis";

function searchGlobal() {
    //console.log($("#suchleiste").val());
}
function searchField() {
    //console.log($("#suchfeld").val());
}

$(document).ready(function () {

    $("form input").bind("keydown", function (event) {
        let form: any = $(dbh_helper.findNearestForm(this));

        if (form.find('.btnPrimarySubmitSearch').length > 0) {
            let keycode = (event.keyCode ? event.keyCode : (event.which ? event.which : event.charCode));

            if (keycode == 13) {
                form.find('.btnPrimarySubmitSearch').first().get(0).click();
                return false;
            } else {
                return true;
            }
        }        
    });

    $(document).on('click', '.btnPrimarySubmitSearch', function (e) {
        let form: any = $(dbh_helper.findNearestForm(this));

        //console.log("Test: ", dbh_helper.getParameterStringForForm(form));

        let action: string = form.attr('action');
        new dbh_ajax().sendPostRequest({
            csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
            actionName: action.substring(action.lastIndexOf('/') + 1),
            controllerName: action.substring(1, action.lastIndexOf('/')),
            parameter: dbh_helper.getParameterStringForForm(form),
            callbackSuccess: (ajaxResult: any) => {
                //console.log(ajaxResult);

                var ergebnisWrapper = $(form).find('.dbhSuchergebnisWrapper').first();
                ergebnisWrapper.replaceWith(ajaxResult);
                new dbh_suchergebnis().restoreTableHeader();
                new dbh_suchergebnis().setMouseWheelClick();
            },
            callbackError: (ajaxResult: any) => {
            }
        });

        e.stopPropagation();
    });

    new dbh_suchergebnis().restoreTableHeader();
});
